import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {

    --blackGreen: #001f0f;
    --white: #fff;
    --lightGreen: rgb(0, 63, 14);
    --beige: rgb(251, 247, 236);;
  --focus: rgb(123, 212, 32);
    --margin: 10px;
    --opacity: 1;
    --opacityOver: 0.5;
  }
  html {
 cursor:url('/LeafSelect2.cur'), auto;
    background-size: 450px;
    background-attachment: fixed;
    font-size: 1.6vh;

  }

  body {
    font-size: 1rem;
    height: 100%;
  }


  ul {
    list-style: none;
  }

  .link-list, .nav-links a {
    transition: all 0.1s ease-out;
  }

  .active {
  /* opacity: var(--opacityOver) !important; */
  color: var(--focus) !important;
  }

  .active .vignette{
    -webkit-filter: none; /* Safari 6.0 - 9.0 */
    filter:none;
  }


  .all-active {
    opacity: var(--opacityOver) !important;
  }

  .focus-active {
  color: var(--focus) !important;

  }

  .focus-active .vignette{
  -webkit-filter: none; /* Safari 6.0 - 9.0 */
  filter:none;
  }

  .logo-ul .vignette {

  -webkit-filter: none; /* Safari 6.0 - 9.0 */
  filter:none;

  }

  .hiden {
    display: none !important;
  }

  .not-active {
    opacity: 1;
  }

  p, h1, h2, h3, h4, h5, ul, li {
    padding: 0;
    margin: 0;
    margin-bottom: 0.5rem;

  }




  .gatsby-image-wrapper img[src*=base64] {
    image-rendering: -moz-crisp-edges;
    image-rendering: smooth;
  }

/* .gatsby-image-wrapper {
  -webkit-animation: fadein 0.8s;
       -moz-animation: fadein 0.8s;
        -ms-animation: fadein 0.8s;
         -o-animation: fadein 0.8s;
            animation: fadein 0.8s;
} */

  @keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}


  /* Scrollbar Styles */
  body::-webkit-scrollbar {
    width: 12px;
  }
  html {
    scrollbar-width: thin;
    scrollbar-color: var(--lightGreen) var(--white);
  }
  body::-webkit-scrollbar-track {
    background: var(--white);
  }
  body::-webkit-scrollbar-thumb {
    background-color: var(--lightGreen) ;
    border-radius: 6px;
    border: 3px solid var(--white);
  }


  a {
    display: block;
  }

  a.hover {
    opacity: 1 !important;
  }



  .vignette {
    -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
    filter: grayscale(100%);
    max-width: 9.3rem;
      & img {
          object-fit: contain !important;
      }
    margin-bottom: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .imageBox {
    cursor: pointer;
  }



`;

export default GlobalStyles;
